// extracted by mini-css-extract-plugin
export default {"root":"_1dKECHopxU-F16HeG8LzIE","uploadIcon":"_9Qs_37obPDEU8K2GZSr6b"};